// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"170":"abed4c24","206":"42333f7b","304":"576f4eb0","800":"07a44091"}[chunkId] + ".chunk.css";
};